var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRunModel = function SvgIconRunModel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.909 7.592 6.167 2.15a2.73 2.73 0 0 0-2.7 0 2.77 2.77 0 0 0-1.2 2.5v10.817a2.78 2.78 0 0 0 1.2 2.5c.372.224.8.34 1.233.333a3.3 3.3 0 0 0 1.467-.375L16.91 12.5c1.591-.833 1.825-1.867 1.825-2.433 0-.567-.234-1.667-1.825-2.475m-.759 3.383L5.417 16.417a1.15 1.15 0 0 1-1.083.1 1.2 1.2 0 0 1-.4-1.05V4.583a1.19 1.19 0 0 1 .4-1.05.7.7 0 0 1 .333-.091c.251.01.497.078.717.2L16.15 9.083c.567.284.917.65.917.942s-.35.658-.917.95"
  })));
};
export default SvgIconRunModel;